import { Input, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import FormWrapper from './FormWrapper';
import FormActionButton from '../../ui/FormActionButton';
import Title from '../../ui/Title';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { fetchSubscriptionPlanList } from '../../../store/slices/subscription-plan-slice';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_NAME = process.env.REACT_APP_USER_NAME;
const PASSWORD = process.env.REACT_APP_PASSWORD;

const SubscriptionPlanForm = () => {
    const [subscriptionPlanName, setSubscriptionPlanName] = useState('');
    const [subscriptionFees, setSubscriptionFees] = useState('');
    const [services, setServices] = useState('');
    const [duration, setDuration] = useState('');

    const [api, contextHolder] = notification.useNotification();

    const [searchParams] = useSearchParams();
    const MODE = searchParams.get('mode');
    const navigate = useNavigate();
    const { data: subscriptionPlanList } = useSelector((state) => state.subscriptionPlan);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchSubscriptionPlanList());
    }, []);

    useEffect(() => {
        if(MODE === 'EDIT' && subscriptionPlanList.length) {
            const ID = searchParams.get('id');
            const selectedSubscriptionPlan = subscriptionPlanList.filter((item) => item.subscription_plan_id === ID);
            setSubscriptionPlanName(selectedSubscriptionPlan[0].subscription_plan_name);
            setSubscriptionFees(selectedSubscriptionPlan[0].subscription_fees);
            setServices(selectedSubscriptionPlan[0].services);
            setDuration(selectedSubscriptionPlan[0].duration);
        }
        if(MODE === 'ADD') {
            resetHandler();
        }
    }, [MODE, subscriptionPlanList]);

    const openNotification = ({type, message, description}) => {
        api[type]({
            message,
            description,
            placement: 'bottomRight',
        });
    }

    const submitHandler = async (e) => {
        e.preventDefault();
        const details = {
            'subscription_plan_name': subscriptionPlanName,
            'subscription_fees': subscriptionFees,
            'services': services,
            'duration': duration,
        };
        if(MODE === 'EDIT') {
            const ID = searchParams.get('id');
            details.subscription_plan_id = ID;
        }

        var formBody = [];
        for (var property in details) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");

        try {
            const response = await fetch(`${API_BASE_URL}/subscription-plans/${MODE === 'ADD' ? 'add' : 'edit'}`, {
                method: 'POST',
                headers: { 
                    'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formBody
            });
            const responseData = await response.json();

            if(responseData.code === 200) {
                openNotification(
                    { 
                        type: 'success',
                        message: 'Successfully Submitted!', 
                        description: responseData.message,
                    }
                );
                resetHandler();
                if(MODE === 'EDIT') {
                    setTimeout(() => {
                        navigate('/dashboard/subscription-plan-list');
                    }, 1500);
                }
            } else {
                openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        description: responseData.message,
                    }
                );
            }
        } catch (error) {
            openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        // description: error,
                    }
                );
        }
        
        
    }
    const resetHandler = () => {
        setSubscriptionPlanName('');
        setSubscriptionFees('');
        setServices('');
        setDuration('');
    }
    return (
        <FormWrapper>
            {contextHolder}
            <Title>{MODE} Subscription Plan</Title>
            <form onSubmit={submitHandler}>
                <div className='control'>
                    <label>Subscription Plan Name:</label>
                    <Input 
                        onChange={(e) => setSubscriptionPlanName(e.target.value)}
                        value={subscriptionPlanName} 
                        size='large' 
                        placeholder='Subscription Plan Name' 
                    />
                </div>
                <div className='control'>
                    <label>Subscription Fees:</label>
                    <Input 
                        onChange={(e) => setSubscriptionFees(e.target.value)}
                        value={subscriptionFees}
                        size='large' 
                        placeholder='Subscription Fees' 
                    />
                </div>
                <div className='control'>
                    <label>Services:</label>
                    <Input 
                        onChange={(e) => setServices(e.target.value)}
                        value={services}
                        size='large' 
                        placeholder='Services' 
                    />
                </div>
                <div className='control'>
                    <label>Duration:</label>
                    <Input
                        onChange={(e) => setDuration(e.target.value)}
                        value={duration} 
                        size='large' 
                        placeholder='Duration' 
                    />
                </div>
                <div className='control'>
                    <FormActionButton bg='#ff6b6b' onClick={resetHandler} type='button'>
                        Reset 
                    </FormActionButton>
                    <FormActionButton type='submit' bg='#10ac84'>
                        Submit 
                    </FormActionButton>
                </div>
            </form>
        </FormWrapper>
    );
}

export default SubscriptionPlanForm;


